const HomeVar={
    title:"Drake Mitchell",
    subtitle:"Game Developer | Software Engineer",
    aboutMe:`I am a Software Engineer and Game Developer with a strong foundation in many different languages\n\nMy background in Game Development has geared me for working in diverse groups, following AGILE principles and utilizing many different programs and coding languages.\n\nAs a Software Engineer, I wish to keep expanding my talents, learn new languages, and strategies to tackle problems effectively.\n\nAs a Game Developer, my dream is to develop my own games and experiences to entertain and inspire the gaming community.`,
    aboutMeImg:"./DrakeM.jpg"

}

export default HomeVar